import React from 'react';
import { Button } from '../../components/ui/Button';
import { MapPinIcon } from 'lucide-react';
export function AboutSection() {
  return <section data-id="element-2513">
      <div className="relative bg-cover bg-center py-20 md:py-32" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/488WLWcTFJDWgc1MqH354f/About-Peak-EDM.jpg)'
    }} data-id="element-2514">
        <div className="absolute inset-0 bg-[rgba(0,40,70,0.75)]" data-id="element-2515"></div>
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2516">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-2517">
            About Peak Machine Sales (Peak EDM Inc.)
          </h2>
          <p className="text-xl md:text-2xl text-white/90 leading-relaxed mb-6 max-w-4xl mx-auto" data-id="element-2518">
            Established in 1995, Peak Machine Sales is Michigan's trusted
            provider of CNC machine tool sales and service, delivering tailored
            solutions and factory-trained support.
          </p>
          <div className="flex items-center justify-center text-white/80" data-id="element-2519">
            <MapPinIcon className="w-5 h-5 text-orange mr-3 flex-shrink-0" data-id="element-2520" />
            <span className="text-lg" data-id="element-2521">
              <span className="font-semibold text-white" data-id="element-2522">
                Offices in Wixom & Kalamazoo
              </span>{' '}
              • Supporting manufacturers statewide
            </span>
          </div>
        </div>
      </div>

      <div className="py-16 md:py-24 bg-white" data-id="element-2523">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2524">
          <div className="space-y-6 text-gray-700 leading-relaxed" data-id="element-2525">
            <p data-id="element-2526">
              At Peak Machine Sales, we take immense pride in representing some
              of the most impressive CNC machine tool lines in the industry.
              But, we're not just about selling machines. We're about
              understanding the unique needs and challenges of each of our
              customers. We tailor our offerings to fit like a glove, ensuring
              you get the most out of the solutions we have to offer.
            </p>
            <p data-id="element-2527">
              Established in 1995, Peak Machine Sales stands as Michigan's
              foremost provider of CNC machine tool sales and service. Our
              expertise spans across High-Speed 3 & 5 Axis Milling, Conventional
              Milling & Turning, Wire and Sinker EDM, Laser Cutting, Additive
              Manufacturing (3D Printing), Tooling, and Automation. Renowned for
              our commitment to quality customer support, we've assembled a team
              of highly skilled professionals dedicated to serving the Die Mold
              and precision part production industries. With strategically
              located offices in Wixom and Kalamazoo, Peak ensures comprehensive
              support for our product lines across the entire State of Michigan.
              Our deliberate selection of cutting-edge brands reflects our
              commitment to pioneering machining technology and manufacturing
              trends. Backed by factory-trained Peak Service Engineers, we
              ensure seamless service, directly supported by the OEMs we
              represent. This privileged access to internal databases empowers
              us to deliver factory-level service promptly and efficiently.
            </p>
            <p data-id="element-2528">
              If you're curious to see how our CNC machine tools can work
              wonders for your business, please don't hesitate to drop us a
              line, shoot us a message, or give us a ring. We're always up for a
              chat, and we'd love to hear your goals and explore how our team
              can help you reach them. Thanks for considering Peak Machine Sales
              as your trusted source for precision CNC machines in Michigan. We
              look forward to building a fantastic partnership.
            </p>
          </div>
          <div className="mt-8" data-id="element-2529">
            <Button variant="primary" href="8.html" data-id="element-2530">
              Learn More About Peak
            </Button>
          </div>
        </div>
      </div>
    </section>;
}